import { useContext } from "react";
import { Route, Routes } from "react-router-dom";
import { RecoilRoot } from "recoil";
import PageNotFound from "../../util/page/PageNotFound";
import { GlobalContext } from "../../util/state/GlobalContextProvider";
import {
    InsertBookingPage,
    BookingSearchPage,
    ViewBookingPage,
    InsertRulePage,
    RulesPage,
    PendingListPage,
    ImportPage,
    DashboardPage,
    ViewDisambiguation,
    EditBooking,
    RequestSubstitutionPage
} from "./pages";
import { BookingScope } from "./types";
import { hasScope } from "./utils";
import NotAuthorizedDialog from "../authentication/component/NotAuthorizedDialog";

const BookingMain = () => {

    const { globalData } = useContext(GlobalContext);

    if (!hasScope(globalData, BookingScope.Booking)) {
        return null;
    }

    return (
        <Routes>
            <Route
                path="/insert"
                element={
                    hasScope(globalData, BookingScope.InsertBooking) ?
                        <RecoilRoot key='booking.insert'>
                            <InsertBookingPage />
                        </RecoilRoot> :
                        <NotAuthorizedDialog />
                }
            />
            <Route
                path="/list/*"
                element={
                    (hasScope(globalData, BookingScope.SearchBookings) || hasScope(globalData, BookingScope.SearchBookingsFromCustomer) ||  hasScope(globalData, BookingScope.SearchBookingsFromSM) ) ?
                        <RecoilRoot key='booking.search'>
                            <BookingSearchPage />
                        </RecoilRoot> :
                        <NotAuthorizedDialog />
                }
            />
            <Route
                path="/view/:id"
                element={
                    (hasScope(globalData, BookingScope.SearchBookings) ||
                        hasScope(globalData, BookingScope.SearchBookingsFromCustomer) ||
                        hasScope(globalData, BookingScope.SearchBookingsFromSM) ||
                        hasScope(globalData, BookingScope.ViewAllBooking) ||
                        hasScope(globalData, BookingScope.ViewLocalBooking)) ?
                        <RecoilRoot key='booking.view'>
                            <ViewBookingPage />
                        </RecoilRoot> :
                        <NotAuthorizedDialog />
                }
            />
            <Route
                path="/view-disambiguation/:id"
                element={
                    hasScope(globalData, BookingScope.Import) ?
                        <RecoilRoot key='booking.view-disambiguation'>
                            <ViewDisambiguation />
                        </RecoilRoot>
                        :
                        <NotAuthorizedDialog />
                }
            />
            <Route
                path="/edit/:id"
                element={
                    hasScope(globalData, BookingScope.HardEditing) ?
                        <RecoilRoot key='booking.edit'>
                            <EditBooking />
                        </RecoilRoot> :
                        <NotAuthorizedDialog />
                }
            />
            <Route
                path="/request-substitution/:id"
                element={
                    (hasScope(globalData, BookingScope.SearchBookings) ||
                        hasScope(globalData, BookingScope.SearchBookingsFromCustomer) ||
                        hasScope(globalData, BookingScope.SearchBookingsFromSM) ||
                        hasScope(globalData, BookingScope.ViewAllBooking) ||
                        hasScope(globalData, BookingScope.ViewLocalBooking)) ?
                        <RecoilRoot key='booking.request-substitution'>
                            <RequestSubstitutionPage />
                        </RecoilRoot> :
                        <NotAuthorizedDialog />
                } />
            <Route path="/rules">
                <Route
                    index
                    element={
                        hasScope(globalData, BookingScope.Rules) ?
                            <RecoilRoot key='booking.rules'>
                                <RulesPage />
                            </RecoilRoot> :
                            <NotAuthorizedDialog />
                    }
                />
                <Route
                    path="insert"
                    element={
                        hasScope(globalData, BookingScope.CreateEditRule) ?
                            <RecoilRoot key='booking.rules.insert'>
                                <InsertRulePage />
                            </RecoilRoot> :
                            <NotAuthorizedDialog />
                    }
                />
            </Route>
            <Route
                path="/pending-list"
                element={
                    hasScope(globalData, BookingScope.PendingList) ?
                        <RecoilRoot key='booking.pendingList'>
                            <PendingListPage />
                        </RecoilRoot> :
                        <NotAuthorizedDialog />
                }
            />
            <Route
                path="/import"
                element={
                    hasScope(globalData, BookingScope.Import) ?
                        <RecoilRoot key='booking.import'>
                            <ImportPage />
                        </RecoilRoot> :
                        <NotAuthorizedDialog />
                }
            />
            <Route
                path="/dashboard"
                element={
                    hasScope(globalData, BookingScope.Dashboard) ?
                        <RecoilRoot key='booking.dashboard'>
                            <DashboardPage />
                        </RecoilRoot> :
                        <NotAuthorizedDialog />
                }
            />
            <Route
                path="*"
                element={<PageNotFound />}
            />
        </Routes >
    );
}

export default BookingMain;
